<template>
    <div @click="hide">

        <!-- modal -->
        <div v-show="isShowing" class="modal fade has-shown show p-2" tabindex="-1" role="dialog" style="display:block;">
            <div class="modal-dialog" role="document" :class="{'modal-dialog-centered': centered, 'modal-dialog-scrollable': scrollable}">
                <div class="modal-content" @click.stop>
                    <slot/>
                </div>
            </div>
        </div>

        <!-- backdrop -->
        <div v-show="isShowing" class="modal-backdrop fade show"></div>

    </div>
</template>

<script>
    export default {
        props: {
            centered: {
                type: [Boolean],
                default: false,
            },
            scrollable: {
                type: [Boolean],
                default: false,
            },
        },
        data: function() {
            return {
                isShowing: false,
            };
        },
        methods: {
            show: function() {
                $('body').addClass('modal-open');
                this.$emit('show');
                this.isShowing = true;
            },
            hide: function() {
                $('body').removeClass('modal-open');
                this.$emit('hide');
                this.isShowing = false;
            },
        },
    }
</script>
